import EnvisionDocumentDialog from "./EnvisionDocumentDialog";

const EnvisionDocumentPropertiesPanel = ({formId, envisionDocumentSchema, saveEnvisionDocumentData, formData, readOnly, handleFormChange }) => {
    return (
        <div>
            <EnvisionDocumentDialog formId={formId} envisionDocumentSchema={envisionDocumentSchema}
              saveEnvisionDocumentData={saveEnvisionDocumentData} formData={formData}
              handleFormChange={handleFormChange} readOnly={readOnly}/>
              
          </div>

    );
}

export default EnvisionDocumentPropertiesPanel;